import { Percent } from '@uniswap/sdk-core'

export const formatPriceImpact = (priceImpact: Percent) => `${priceImpact.multiply(-1).toFixed(2)}%`

/**
 * Formatted version of price impact text with warning colors
 */
export default function FormattedPriceImpact({ priceImpact }: { priceImpact?: Percent }) {
  return <span>{priceImpact ? formatPriceImpact(priceImpact) : '-'}</span>
}
